export const getPoolRequestCount = (state) =>
    state.poolRequest.poolRequests.maxCount;